import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M36.6,30.3 L42.6,30.3 L52,61 L46.7,61 L44.7,54.6 L34.5,54.6 L32.5,61 L27.2,61 Z M39.6,37.9 L35.9,50 L43.3,50 Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
